// extracted by mini-css-extract-plugin
export default {"filters":"DeviceBrandsScreen_filters__mmTQI"};